module.exports = __webpack_public_path__ + "static/media/marchio confindustria sfondo.505378be.png";